import { useRef, useState } from 'react';
import { useMutation } from '@apollo/client';
import { useNotifications } from 'modules/notification';
import { buildPdfHtml } from 'hooks/usePdf';
import { REQUEST_SUBSIDY_CERTIFICATE_PDF } from '../api';

interface Params {
  subsidyRequestId: string;
}

export function useSubsidyCertificatePdf({ subsidyRequestId }: Params) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const { showNotification } = useNotifications();

  const [requestCertificatePDF] = useMutation<{ requestSubsidyCertificatePDF: string | null }>(
    REQUEST_SUBSIDY_CERTIFICATE_PDF
  );

  const handleRequestPdf = async () => {
    if (!contentRef.current) return;
    setIsGenerating(true);
    try {
      const html = buildPdfHtml(contentRef.current);
      const { data, errors } = await requestCertificatePDF({
        variables: {
          input: {
            html,
            subsidyRequestId,
          },
        },
      });

      if (errors?.length || !data?.requestSubsidyCertificatePDF) {
        showNotification('Failed to generate certificate PDF. Please try again.', { type: 'error' });
        return;
      }

      const pdfWindow = window.open('');
      if (pdfWindow) {
        pdfWindow.location.href = data.requestSubsidyCertificatePDF;
      }
    } catch {
      showNotification('Failed to generate certificate PDF. Please try again.', { type: 'error' });
    } finally {
      setIsGenerating(false);
    }
  };

  return { contentRef, isGenerating, handleRequestPdf };
}
